module.exports = __webpack_public_path__ + "static/media/5_uh-oh-cavity-monsters-coming.f866f1a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/5_uh-oh-cavity-monsters-coming.mp3
// module id = TrNB
// module chunks = 0